import moment from "moment";

import type { default as TakeoffSettingsAPIResponseExample } from "./TakeoffSettings.api.json";

export type TakeoffSettingsFormActions = undefined | "back" | "cancel" | "connect" | "disconnect";

export class TakeoffSettingsEntity {
    constructor(data: typeof TakeoffSettingsAPIResponseExample) {
        if (data) {
            this.isConnected = data.isConnected;
            if (data.account) {
                this.account = new PartnerAccount(data.account);
            }
            if (data.connectedUsers) {
                this.connectedUsers = data.connectedUsers.map((m) => new PartnerAccountUser(m));
            }
        }
    }
    isConnected: boolean;
    account: PartnerAccount;
    connectedUsers: PartnerAccountUser[];
}

export class PartnerAccount {
    constructor(data: any) {
        if (data) {
            this.partnerAccountId = data.partnerAccountId;
            this.dateConnected = moment(data.dateConnected);
        }
    }

    partnerAccountId: string;
    dateConnected: moment.Moment;
}

export class PartnerAccountUser {
    constructor(data: any) {
        if (data) {
            this.name = data.name;
            this.userId = data.userId;
            this.partnerUserId = data.partnerUserId;
            this.dateConnected = moment(data.dateConnected);
            this.roleName = data.roleName;
        }
    }

    name: string;
    userId: number;
    partnerUserId: string;
    dateConnected: moment.Moment;
    roleName: string;
}

export class PartnerInfo {
    constructor(data: any) {
        this.id = data.id;
        this.name = data.name;
        this.url = data.url;
        this.loginUrl = data.loginUrl;
    }
    id: number;
    name: string;
    url: string;
    loginUrl: string;
}

export class PartnerRedirectInfoResponse {
    constructor(data: any) {
        this.authorizationUrl = data.authorizationUrl;
    }
    authorizationUrl: string;
}

export class PartnerAccountDisconnectResponse {}
